declare global {
    interface Window {
        getAddress?: {
            autocomplete: (inputId: string, apiKey: string, options?: any) => void;
        };
    }
}

interface AutoCompleteAddress {
    latitude: string;
    longitude: string;
    [key: string]: any;
}

export class AdviserSearch {
    private apiKey: string;
    private searchInput: HTMLInputElement | null;
    private searchButton: HTMLButtonElement | null;

    constructor(apiKey: string) {
        this.apiKey = apiKey;
        this.searchInput = document.getElementById('adviser-search-input') as HTMLInputElement;
        this.searchButton = document.querySelector('button[type="button"]') as HTMLButtonElement;

        if (!this.searchInput) {
            console.error('Input element with id "adviser-search-input" not found');
            return;
        }

        if (!this.searchButton) {
            console.error('Search button not found');
            return;
        }

        this.init();
    }

    private init(): void {
        // Add input event listener to dynamically enable/disable button
        this.searchInput.addEventListener('input', this.validatePostcode.bind(this));
        
        // Add keydown event listener to handle Enter key
        this.searchInput.addEventListener('keydown', this.handleKeyDown.bind(this));
        
        // Add click event listener to search button
        this.searchButton.addEventListener('click', this.handleSubmit.bind(this));
    }

    private validatePostcode(): void {
        const postcode = this.searchInput.value.trim();
        
        // UK Postcode Validation Regex
        const postcodeRegex = /^([A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$/i;
        
        // Enable/disable button based on postcode validity
        if (this.searchButton) {
            this.searchButton.disabled = !postcodeRegex.test(postcode);
        }
    }

    private handleKeyDown(event: KeyboardEvent): void {
        // Trigger search on Enter key
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSubmit();
        }
    }

    private handleSubmit(): void {
        if (!this.searchInput) return;

        const postcode = this.searchInput.value.trim();
        
        // UK Postcode Validation Regex
        const postcodeRegex = /^([A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$/i;
        
        if (!postcodeRegex.test(postcode)) {
            console.warn('Invalid postcode entered');
            return;
        }

        // Convert postcode to lowercase and strip spaces
        const formattedPostcode = postcode.toLowerCase().replace(/\s/g, '');

        // Redirect to advisers page with postcode
        window.location.href = `/advisers/${formattedPostcode}`;
    }
}